<div class="datagrid">
  <div class="section section--with-rounded-bg section--edit-on-the-go">
    @if (showSideBar) {
    <div class="datagrid-sidebar" [@slideInOutSidebar]>
      @if (sideBarType === SideBarTypes.Filters) {
      <cx-adv-filters [module]="module" (temp)="onTempView($event)" [tempView]="tempView"
        (update)="onUpdateView($event)" (create)="onCreateView($event)" (updateview)="onUpdateViewName($event)"
        (check)="onCheck($event)" [selectedView]="selectedView" [views]="views" [fields]="fields"
        (close)="onFiltersClose($event); showSideBar = false">
      </cx-adv-filters>
      }
      <!-- @if (sideBarType === SideBarTypes.Exports && rows.length > 0) {
        <cx-export-modal (export)="onExport($event)" (close)="showSideBar = false"></cx-export-modal> -->
      <!-- } -->
      <!-- @if (sideBarType === SideBarTypes.Schedular) {
        <cx-schedular [views]="views" [module]="module" (close)="showSideBar = false">
        </cx-schedular>
        } -->
      @if ((sideBarType === SideBarTypes.Columns || sideBarType === SideBarTypes.Exports || sideBarType ===
      SideBarTypes.Schedular) && rows.length > 0) {
      <cx-datagrid-settings [sideBarType]="sideBarType" [showExport]="showExport" [showCardView]="showCardView" (export)="onExport($event)" [views]="views" [module]="module"
        (mode)="onModeChange($event)" [columns]="columns" (close)="showSideBar = false" (save)="onSave($event)" [moreOptions]="moreOptions"></cx-datagrid-settings>
      }
    </div>
    }
    <div class="datagrid-container">
      <div class="datagrid-filter">
        <div>
          @if (gridtabs && gridtabs.length > 0) {
            <div class="grid-tabs">
              @for (tab of gridtabs; track tab.value) {
              <a (click)="onTabChange($event, tab.value)" href="#"
                [class]="(tab.value === selectedTab ? 'active ' : '') + 'tab'">{{ tab.name }}</a>
              }
            </div>
          } @else {
            <h2>{{ title }}</h2>
          }
        </div>
        <div class="datagrid-actions">
          <!-- @if (showModes) {
            <div class="action__item" (click)="onModeChange(GridMode.Grid)"><a
              [ngClass]="{ 'active' : gridMode == GridMode.Grid }" class="link-icon"><i
                class="fa-thin fa-grid-2"></i></a></div>
            <div class="action__item" (click)="onModeChange(GridMode.List)"> <a
                [ngClass]="{ 'active' : gridMode == GridMode.List }" class="link-icon"><i
                  class="fa-thin fa-list"></i></a>
            </div>
          } -->

          <div class="action__item">
            <div class="input-group">
              <div class="search-module search-module--secondary">
                <input style="min-width: 276px;" #search [(ngModel)]="searchQuery" type="text"
                  [placeholder]="inputPlaceholder" class="search-module__input">
                <i (click)="onSearch($event)" class="fa-regular fa-magnifying-glass search-module__icon"></i>
              </div>
            </div>
          </div>

          <div class="action__item dropdown--container">
            <div class="dropdown-list action__item dropdown--container">
              <f-dropdown [filter]="true" [dropdownName]="'View'" [style]="{ minWidth: '198px' }" [options]="views"
                (ngModelChange)="onViewChange($event, true)" [(ngModel)]="selectedView" placeholder="Select a view"
                optionValue="vid" optionLabel="name">

                <ng-template pTemplate="dropdownname">
                  <div>
                    <span>View</span>
                  </div>
                  <!-- <i class="fa-light fa-filter"></i> -->
                </ng-template>

                <!-- <ng-template pTemplate="rightarea">
                  <div class="right-area-actions">
                    <a (click)="$event.preventDefault(); $event.stopPropagation(); onShowSideBar(SideBarTypes.Filters)">
                      <i [class]="'fa-light' + (selectedView ? ' fa-pencil' : ' fa-circle-plus')"></i>
                    </a>
                  </div>
                </ng-template> -->

                <ng-template let-item pTemplate="item">
                  <div class="d-flex align-items-center justify-content-between gap-2">
                    <div [title]="item.name">{{ item.name | cxsplice:0:20 }}</div>

                    <div class="d-flex align-items-center justify-content-between gap-2">
                      @if (item.showPined !== false && !item.pined) {
                      <span (click)="setViewPinned($event, item)" class="unpin-icon">
                        <i class="fa-solid fa-thumbtack"></i>
                      </span>
                      } @else if (item.showPined !== false) {
                      <span (click)="setViewPinned($event, item)" class="dropdown unpin-icon unpin">
                        <i class="fa-solid fa-thumbtack"></i>
                      </span>
                      }
                      @if (item.showPined !== false) {
                      <span (click)="deleteView($event, item.id)" class="unpin-icon action-btn">
                        <i class="fa-solid fa-trash"></i>
                      </span>
                      <span (click)="editView($event, item)" class="unpin-icon action-btn">
                        <i class="fa-solid fa-edit"></i>
                      </span>
                      }

                    </div>
                  </div>
                </ng-template>
              </f-dropdown>
            </div>
          </div>

          <div class="action__item sub-action--container">
            @if (showActions) {

            <p-overlayPanel #op>
              <ng-template pTemplate="content">
                <div class="grid-action-menu">
                  <ul>
                    <li (click)="onShowSideBar(SideBarTypes.Columns); op.toggle($event)">
                      <i class="fa-light fa-gear"></i>
                      <span>Grid Settings</span>
                    </li>
                    <li *ngIf="showExport" (click)="onShowSideBar(SideBarTypes.Exports); op.toggle($event)">
                      <i class="fa-light fa-file-export"></i>
                      <span>Export</span>
                    </li>
                    <!-- <li (click)="onShowSideBar(SideBarTypes.Schedular); op.toggle($event)">
                      <i class="fa-light fa-calendar-lines-pen"></i>
                      <span>Scheduler</span>
                    </li> -->
                    <li (click)="onRefresh($event); op.toggle($event)">
                      <i class="fa-light fa-rotate-right"></i>
                      <span>Refresh</span>
                    </li>
                  </ul>
                </div>
              </ng-template>
            </p-overlayPanel>

            <div [@slideInOutSidebar] class="sub__actions">
              <!-- <a title="Filters" (click)="onShowSideBar(SideBarTypes.Filters)" class="link-icon">
                <i class="fa-light fa-filters"></i>
                @if (selectedView) {
                  <i class="indicator"></i>
                }
              </a> -->
              @if (rows.length > 0) {
              <a title="Settings" (click)="op.toggle($event)" class="link-icon"><i
                  class="fa fa-ellipsis-vertical"></i></a>
              <!-- <a title="Exports"  (click)="onShowSideBar(SideBarTypes.Exports)" class="link-icon"><i
                    class="fa-light fa-file-export"></i></a> -->
              }

              <!-- <a title="Schedular" (click)="onShowSideBar(SideBarTypes.Schedular)" class="link-icon"><i
                  class="fa-light fa-calendar-lines-pen"></i></a> -->
              <!-- <a title="Refresh" (click)="onRefresh($event)" class="link-icon"><i class="fa-light fa-rotate-right"></i></a> -->
            </div>
            }
          </div>
        </div>

        <!-- <div class="datagrid-actions-handle" (click)="showActions = !showActions">
          <div class="action__item"> <a [hidden]="showActions" class="link-icon"><i
            class="fa-light fa-arrow-left-long-to-line"></i></a>
          </div>
          <div class="action__item">
            <a class="link-icon" [hidden]="!showActions"><i
                class="fa-light fa-arrow-right-long-to-line"></i></a>
          </div>
        </div> -->
      </div>
      <div class="datagrid-tabs">
        <div class="created__filtes">
          @for (view of getPinnedViews(); track view.vid) {
          <button class="btn-bg d-flex view"
            (click)="selectedView = view.vid; showSideBar = false; onViewChange($event)"
            [ngClass]="{ 'in-active': selectedView != view.vid }">
            <span [title]="view.name">{{ view.name | cxsplice:0:20 }}</span>
            <div class="d-flex align-items-center justify-content-between gap-2">
              @if (view.showPined !== false) {
              <span class="unpin-icon unpin" [ngClass]="{ 'active': selectedView == view.vid }"
                (click)="setViewPinned($event, view); showSideBar = false;">
                <i class="fa-solid fa-thumbtack"></i>
              </span>
              }

              @if (view.id && view.showPined !== false) {
              <span (click)="deleteView($event, view.id)" class="unpin-icon action-btn">
                <i class="fa-solid fa-trash"></i>
              </span>

              @if (view.showPined !== false) {
              <span
                (click)="$event.preventDefault(); $event.stopPropagation(); selectedView = view.vid; showSideBar = false; onViewChange($event); onShowSideBar(SideBarTypes.Filters)"
                class="unpin-icon action-btn">
                <i class="fa-solid fa-edit"></i>
              </span>
              }
              }

            </div>
          </button>
          }
        <!--- /Old Condition/ -->
        <!-- tableService.showRowActions && !tableService.showSelectAllActions  -->
        <!-- above is removed because this will be handled from template -->
        </div>
        
         
        
        <div class="tabs__ddlist">
          @if (actionButtonTemplate) {
            <ng-template [ngTemplateOutlet]="actionButtonTemplate"
            [ngTemplateOutletContext]="{ ctx: { columns: tableService.columns | cxShowable:{ gridMode: gridMode }, gridMode: gridMode } }"></ng-template>
          }
          @if (tableService.showSelectAllActions || tableService.showRowActions) {
            <button (click)="clearRowSelections()" class="btn-bg btn-primary">Clear Selection<i class="fa-light fa-trash" style="padding-left: 5px;"></i></button>
          }
        @if ((!tableService.showRowActions && !tableService.showSelectAllActions) && showFilters) {
        
          @for (column of tableService.filterColumns; track $index) {
          @if (column.component === 'dropdown') {
          <div class="dropdown-list minimal-dropdown d-flex">
            <f-dropdown [withbox]="false" [filter]="true" [style]="{ width: column.cvalue ? '200px' : '150px' }"
              (ngModelChange)="column.value = $event; onFilter();" [options]="column.options"
              [(ngModel)]="column.cvalue" [placeholder]="'Select ' + column.name" [dropdownName]="column.name"
              optionValue="value" optionLabel="label">
              <!-- <ng-template pTemplate="selectedItem">
                      <div class="flex align-items-center gap-2">
                          <div>{{ column.name }}: {{ column.value }}</div>
                      </div>
                    </ng-template> -->

              <ng-template let-item pTemplate="item">
                <div class="">
                  <div style="font-size: 14px;">{{ item.label }}</div>
                  @if (item.description) { <div>{{ item.description }}</div> }
                </div>
              </ng-template>
            </f-dropdown>
            @if (column.cvalue === 'Custom') {
            <div>
              <advance-daterangepicker [showRanges]="false"
                (apply)="column.value = $event.values; onFilter();"></advance-daterangepicker>
            </div>
            }
          </div>
          } @else if (column.component === 'multiselect') {
          <div class="minimal-dropdown">
            <f-multiSelect [filter]="true" [dropdownName]="column.name" [placeholder]="'Select ' + column.name"
              [style]="{ minWidth: '230px' }" [options]="column.options" [(ngModel)]="column.value">
              <ng-template pTemplate="selectedItems">
                <div class="flex align-items-center">
                  <div style="font-size: 13px; padding: 3px;">{{ column.name }}: {{ column.value }}</div>
                </div>
              </ng-template>
            </f-multiSelect>
          </div>
          } @else {
          <div class="minimal-input">
            <div class="filter-name">{{ column.name }}</div>
            <input [(ngModel)]="column.cvalue" [placeholder]="'Enter ' + column.name"
              (ngModelChange)="onInputFieldChange($event, column)" type="text" />
          </div>
          }
          <div class="pipe"></div>
          }
          <button (click)="onShowSideBar(SideBarTypes.Filters)"
            [ngClass]="getFiltersLength() > 0 ? 'transparent-btn hasfilters' : 'transparent-btn'">
            <i class="fa-light fa-filters"></i>
            <span>Advance Filters</span>
            <span>({{ getFiltersLength() }})</span>
          </button>


       
        }
      </div>
       
      </div> 
      <div class="cx-datagrid">
        @if (noDataTemplate && rows && rows.length === 0) {
        <ng-template [ngTemplateOutlet]="noDataTemplate"
          [ngTemplateOutletContext]="{ ctx: { columns: tableService.columns | cxShowable:{ gridMode: gridMode }, gridMode: gridMode } }"></ng-template>
        }
        @if (random === tableService.random && rows.length && (gridMode === GridMode.Grid || gridMode === GridMode.List)) {
          <table [class]="className + (GridMode.Grid == gridMode ? (' grid-mode') : ' list-mode')"
            [style]="{ 'width': GridMode.Grid == gridMode ? (width + '%') : (((getOnlyShowableColumns().length) * 220) + 'px')  }">
            <thead>
              @if (headerTemplate) {
              <ng-template [ngTemplateOutlet]="headerTemplate"
                [ngTemplateOutletContext]="{ ctx: { columns: tableService.columns | cxShowable:{ gridMode: gridMode }, gridMode: gridMode } }">
              </ng-template>
              }
            </thead>
            <tbody>
              @for (row of rows; track row.id; let index = $index) {
              @if (bodyTemplate) {
              <ng-template [ngTemplateOutlet]="bodyTemplate"
                [ngTemplateOutletContext]="{ ctx: { columns: tableService.columns| cxShowable:{ gridMode: gridMode }, row: row, rowIndex: index, gridMode: gridMode } }">
              </ng-template>
              }
              @if (bodyDetailTemplate && row.rowDetail?.enabled) {
              <ng-template [ngTemplateOutlet]="bodyDetailTemplate"
                [ngTemplateOutletContext]="{ ctx: { columns: tableService.columns| cxShowable:{ gridMode: gridMode }, row: row, rowIndex: index, gridMode: gridMode } }">
              </ng-template>
              }
              }
            </tbody>
          </table>
        } @else if (gridMode === GridMode.Card) {
          <div class="flex-box">
            <div class="flex-col-sm-12 mt-50 ">
              <div class="section__content">
                <ng-scrollbar track="all" style="height: calc(100vh - 200px)">
                  <div class="flex-row mt-20 call-monitor--grid">
                    @for (row of rows; track row.id; let index = $index) {
                      <ng-template [ngTemplateOutlet]="cardViewTemplate"
                        [ngTemplateOutletContext]="{ ctx: { columns: tableService.columns| cxShowable:{ gridMode: gridMode }, row: row, rowIndex: index, gridMode: gridMode } }">
                      </ng-template>
                      }
                  </div>
                </ng-scrollbar>
              </div>
            </div>
          </div>
        }
      </div>
      @if (rows && rows.length) {
      <pagination-controls [maxSize]="pagingConfig.itemsPerPage" (pageChange)="handlePageChange($event)"
        (pageSizeChange)="handlePageSizeChange($event)" [id]="pagingConfig.id" [isNewPreview]="true">
      </pagination-controls>
      }
    </div>

    @if (tableService.showEditColumnModal) {
    <cx-edit-column-modal (close)="tableService.showEditColumnModal = false">
    </cx-edit-column-modal>
    }
    
    @if (tableService.showAddEvaluationSidebar) {
    <div class="secondary-sidepanel secondary-sidepanel--agent-info" style="width: 670px; overflow: auto;"> 
      <agent-call-evaluation-form (close)="tableService.showAddEvaluationSidebar = false">
      </agent-call-evaluation-form>
    </div>
    }
    @if (tableService.showViewEvaluationSidebar) {
      <div class="secondary-sidepanel secondary-sidepanel--agent-info" style="width: 670px; overflow: auto;"> 
        <agent-call-evaluation-form  [isViewMode]="true" [disableActions]="true" (close)="tableService.showViewEvaluationSidebar = false">
        </agent-call-evaluation-form>
      </div>
      }
      @if (tableService.showViewSubmittedEvaluationSidebar) {
        <div class="secondary-sidepanel secondary-sidepanel--agent-info" style="width: 670px; overflow: auto;"> 
          <agent-call-evaluation-form [isViewMode]="true" [disableActions]="false" (close)="tableService.showViewSubmittedEvaluationSidebar = false">
          </agent-call-evaluation-form>
        </div>
      }
      @if (tableService.showTranscriptSidebar) {
        <div class="secondary-sidepanel" style="width: 620px;overflow: auto;"> 
          <agent-call-recording-transcript  (close)="tableService.showTranscriptSidebar = false">
          </agent-call-recording-transcript>
        </div>
        }
    @if (tableService.showViewNameModal) {
    <cx-edit-view-name-modal [view]="editViewRecord" (close)="tableService.showViewNameModal = false"
      (updated)="onViewNameUpdate()">
    </cx-edit-view-name-modal>
    }
  </div>
</div>